import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';

import { CustomizeContext } from '../contexts/customize';

const MtmLabel = () => {
  const [brandLabel, setBrandLabel] = useState();
  const [kamakuraLabel, setKamakuraLabel] = useState();
  const { customizes, setCustomizes } = useContext(CustomizeContext);

  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL
  });
  const productId = document.getElementById('mtm-customize').dataset.productId;

  const onCheckboxSelect = (e) => {
    const checkLabel = (id) => {
      if (id === 'OS03') return true;
      else return false;
    };

    const id = e.target.dataset.id;
    const isBrand = checkLabel(id);

    const label = {
      id: id,
      value: e.target.checked
        ? `${isBrand ? 'ブランド' : '鎌倉'}ネーム無`
        : `${isBrand ? 'ブランド' : '鎌倉'}ネーム有`,
      label: e.target.checked
        ? `Without ${isBrand ? 'Fabric' : 'Brand'} Label`
        : `With ${isBrand ? 'Fabric' : 'Brand'} Label`
    };

    if (isBrand) {
      setCustomizes({
        ...customizes,
        brand_name: { ...label }
      });
    }
    if (!isBrand) {
      setCustomizes({
        ...customizes,
        kamakura_name: { ...label }
      });
    } else return;
  };

  useEffect(() => {
    const getBrandLabel = async () => {
      const response = await client.get(
        '/get_brand_name_option?product_id=' + productId
      );
      const label = {
        id: response.data.result[0].id,
        value: response.data.result[0].value,
        label: response.data.result[0].label
      };

      customizes.brand_name.id = label.id;
      customizes.brand_name.value = label.value;
      customizes.brand_name.label = label.label;
      setCustomizes({ ...customizes });

      return response.data.result[1];
    };
    const getKamakuraLabel = async () => {
      const response = await client.get(
        '/get_name_option?product_id=' + productId
      );
      const label = {
        id: response.data.result[0].id,
        value: response.data.result[0].value,
        label: response.data.result[0].label
      };

      customizes.kamakura_name.id = label.id;
      customizes.kamakura_name.value = label.value;
      customizes.kamakura_name.label = label.label;
      setCustomizes({ ...customizes });

      return response.data.result[1];
    };
    Promise.allSettled([getBrandLabel(), getKamakuraLabel()])
      .then((data) => {
        setBrandLabel(data[0].value);
        setKamakuraLabel(data[1].value);
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <div className="mtm-item__wrapper" id="mtm-label">
      <div className="d-flex align-items-center flex-column flex-md-row mb-5">
        <h3 className="mtm-item__title mb-0">LABEL</h3>
      </div>
      <div className="row w-100">
        {brandLabel && (
          <div className="col-12 col-md-6">
            <label
              className={
                (brandLabel.description ? 'py-5' : 'py-4') +
                ' mtm-label_container mtm-label_container-sp'
              }
            >
              <div>
                <input
                  type="checkbox"
                  value={brandLabel.value}
                  onClick={onCheckboxSelect}
                  data-id={brandLabel.id}
                  data-label={brandLabel.label}
                />
                <span className="mtm-label_checkbox me-3" />
                <span className="mtm-label_checkbox-label">
                  {brandLabel.label}
                </span>
              </div>
              {brandLabel.description && <p>{brandLabel.description}</p>}
            </label>
          </div>
        )}
        {kamakuraLabel && (
          <div className="col-12 col-md-6">
            <label
              className={
                (kamakuraLabel.description ? 'py-5' : 'py-4') +
                ' mtm-label_container'
              }
            >
              <div>
                <input
                  type="checkbox"
                  value={kamakuraLabel.value}
                  onClick={onCheckboxSelect}
                  data-id={kamakuraLabel.id}
                  data-label={kamakuraLabel.label}
                />
                <span className="mtm-label_checkbox me-3" />
                <span className="mtm-label_checkbox-label">
                  {kamakuraLabel.label}
                </span>
              </div>
              {kamakuraLabel.description && <p>{kamakuraLabel.description}</p>}
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default MtmLabel;
